import {Component, Injector, OnInit} from "@angular/core";
import {AudioInputChannel} from "@models";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_AudioInputChannelDialogInput extends MatDialogDataBaseInput {
	audioInputChannel: AudioInputChannel;
}

export interface DialogData_AudioInputChannelDialogOutput extends MatDialogDataBaseOutput {
	updatedAudioInputChannel: AudioInputChannel;
}

@Component({
	selector: "sim-audio-input-channel-configuration-dialog",
	templateUrl: "./audio-input-channel-configuration-dialog.component.html",
	styleUrls: ["./audio-input-channel-configuration-dialog.component.scss"],
	standalone: false,
})
export class AudioInputChannelConfigurationDialogComponent
	extends BasicMaterialDialog<
		AudioInputChannelConfigurationDialogComponent,
		DialogData_AudioInputChannelDialogInput,
		DialogData_AudioInputChannelDialogOutput
	>
	implements OnInit
{
	constructor(_injector: Injector) {
		super(_injector);
	}

	ngOnInit() {
		super.ngOnInit();
		this.init();
	}

	protected init() {}

	saveAudioInputChannel() {
		this.close({
			action: "ok",
			updatedAudioInputChannel: this.data.audioInputChannel,
		});
	}
}
